/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 149.0.0-SNAPSHOT
 */

export type SalesPartnerCreateCustomerSalutationEnum =
  (typeof SalesPartnerCreateCustomerSalutationEnum)[keyof typeof SalesPartnerCreateCustomerSalutationEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SalesPartnerCreateCustomerSalutationEnum = {
  MR: "MR",
  MS: "MS",
  MX: "MX",
} as const;
